import { useRef, useState, useEffect } from "react";

export default function DraggablePill({ children, defaultX = 16, defaultY = 16 }) {
  const ref = useRef(null);
  const [pos, setPos] = useState({ x: defaultX, y: defaultY });
  const [drag, setDrag] = useState({ active: false, offsetX: 0, offsetY: 0 });

  useEffect(() => {
    const onMove = (e) => {
      if (!drag.active) return;
      const p = e.touches ? e.touches[0] : e;
      setPos({ x: p.clientX - drag.offsetX, y: p.clientY - drag.offsetY });
      e.preventDefault();
    };
    const onUp = () => setDrag((d) => ({ ...d, active: false }));

    window.addEventListener("mousemove", onMove, { passive: false });
    window.addEventListener("mouseup", onUp);
    window.addEventListener("touchmove", onMove, { passive: false });
    window.addEventListener("touchend", onUp);
    window.addEventListener("touchcancel", onUp);
    return () => {
      window.removeEventListener("mousemove", onMove);
      window.removeEventListener("mouseup", onUp);
      window.removeEventListener("touchmove", onMove);
      window.removeEventListener("touchend", onUp);
      window.removeEventListener("touchcancel", onUp);
    };
  }, [drag.active, drag.offsetX, drag.offsetY]);

  const onDown = (e) => {
    const rect = ref.current.getBoundingClientRect();
    const p = e.touches ? e.touches[0] : e;
    setDrag({ active: true, offsetX: p.clientX - rect.left, offsetY: p.clientY - rect.top });
    e.preventDefault();
  };

  return (
    <div
      ref={ref}
      onMouseDown={onDown}
      onTouchStart={onDown}
      style={{
        position: "fixed",
        left: pos.x,
        top: pos.y,
        zIndex: 9999,
        cursor: drag.active ? "grabbing" : "grab",
      }}
    >
      {children}
    </div>
  );
}
